import { create } from 'zustand';

import { AppEvent } from './events';

export type Listener<T> = (arg: T) => void;

type State<T> = {
  listeners: Listener<T>[];
  listen: (listener: Listener<T>) => () => void;
  queuedEvents: Record<string, T[]>;
  dispatch: (event: T) => void;
  flushEvents: (type: string) => T[];
  queue: (event: T) => void;
};

export const eventBus = create<State<AppEvent>>((set, get) => ({
  listeners: [],
  queuedEvents: {},
  listen: (listener) => {
    set((state) => ({
      listeners: [...state.listeners, listener],
    }));

    return () => {
      set((state) => ({
        listeners: state.listeners.filter((lis) => lis !== listener),
      }));
    };
  },
  dispatch: (event) => {
    const { listeners } = get();

    listeners.forEach((listener) => {
      listener(event);
    });
  },
  queue: (event) => {
    set((state) => ({
      queuedEvents: {
        ...state.queuedEvents,
        [event.type]: [...(state.queuedEvents[event.type] || []), event],
      },
    }));
  },
  flushEvents: (type) => {
    const { queuedEvents } = get();
    const events = queuedEvents[type] || [];
    set((state) => ({
      queuedEvents: {
        ...state.queuedEvents,
        [type]: [],
      },
    }));
    return events;
  },
}));
